/* Rippin Moto: color cards. A product card whose swatch dots carry a photo
   (data-rm-img, from snippets/rm-card-swatches.liquid) shows a random color
   when the page loads, and hovering or focusing a dot switches the card photo.
   Cards that arrive later (infinite scroll, filters) are picked up by the
   observer. A card marked data-rm-random-photos (the builder card) draws one
   of the listed photos instead; a photo that fails to load is dropped and the
   next one tried. Safe to load more than once. */
(function () {
  'use strict';
  if (window.__rmColorCards) return;
  window.__rmColorCards = true;

  function cardOf(el) {
    return el.closest('[data-rm-color-card], product-card, .rm-cardf, .rm-sub, .rm-line-card');
  }
  function imageOf(card) {
    if (!card) return null;
    var host = card.querySelector('.card-gallery, .rm-cardf__media, .rm-sub__img');
    return (host || card).querySelector('img');
  }
  function show(img, url) {
    if (!img || !url || img.getAttribute('data-rm-current') === url) return;
    img.removeAttribute('srcset');
    img.setAttribute('sizes', '');
    img.src = url;
    img.setAttribute('data-rm-current', url);
  }

  function initSwatches(wrap) {
    if (wrap.__rm) return;
    wrap.__rm = true;
    var dots = Array.prototype.slice.call(wrap.querySelectorAll('[data-rm-img]'));
    if (dots.length < 2) return;
    var card = cardOf(wrap);
    var img = imageOf(card);
    if (!img) return;
    function pick(dot) {
      dots.forEach(function (d) { d.classList.toggle('is-active', d === dot); });
      show(img, dot.getAttribute('data-rm-img'));
    }
    pick(dots[Math.floor(Math.random() * dots.length)]);
    dots.forEach(function (dot) {
      dot.addEventListener('mouseenter', function () { pick(dot); });
      dot.addEventListener('focus', function () { pick(dot); });
    });
  }

  function initRandom(el) {
    if (el.__rm) return;
    el.__rm = true;
    var img = el.tagName === 'IMG' ? el : imageOf(el);
    var list = (el.getAttribute('data-rm-random-photos') || '').split('|').filter(Boolean);
    if (!img || list.length < 2) return;
    function tryOne() {
      if (!list.length) return;
      var url = list.splice(Math.floor(Math.random() * list.length), 1)[0];
      img.onerror = tryOne;
      img.removeAttribute('srcset');
      img.src = url + (url.indexOf('?') < 0 ? '?width=600' : '&width=600');
    }
    tryOne();
  }

  function scan(root) {
    root = root || document;
    if (!root.querySelectorAll) return;
    root.querySelectorAll('[data-rm-color-swatches]').forEach(initSwatches);
    root.querySelectorAll('[data-rm-random-photos]').forEach(initRandom);
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  ready(function () {
    scan(document);
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (records) {
      records.forEach(function (r) {
        r.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); });
      });
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
